import appGlobalScript from '/Users/rwalus/developer/projects/design-system/packages/components/src/assets/scripts/global.ts';
export const globalScripts = appGlobalScript;
